<template>
  <v-row>
    <v-col cols="12" md="6" offset-md="3">
      <form @submit.prevent="save">
        <v-text-field
          v-model="form.name"
          label="Ime *"
        ></v-text-field>
        <FormErrors
          v-if="$v.form.$error && (!$v.form.name.required)"
        >
          <FormErrorsLine v-if="!$v.form.name.required" text="Polje je obvezno" />
        </FormErrors>
        <v-text-field
          v-model="form.discount"
          min="0"
          step=".01"
          type="number"
          @blur="parseDiscountPrice"
          label="Popust"
        ></v-text-field>
        <v-text-field
          v-model="form.value"
          @blur="parseFormPrice"
          label="Vrednost"
        ></v-text-field>
        <v-text-field
          v-model="form.new_value"
          @blur="parseFutureFormPrice"
          label="Nova vrednost"
        ></v-text-field>
        <label class="v-label v-label--active theme--light" :style="{'fontSize': '12px !important', 'top': '12px', 'position': 'relative'}">Veljavnost od:</label>
        <DateSelector
          :date="form.start_date"
          @change="updateDate"
        />
        <FormErrors
          v-if="$v.form.$error && (!$v.form.start_date.required)"
        >
          <FormErrorsLine v-if="!$v.form.start_date.required" text="Polje je obvezno" />
        </FormErrors>
        <v-select
          v-if="false"
          :items="printPaymentTypes"
          item-text="name"
          item-value="id"
          v-model="form.print_payment_type"
          label="Prikaz na računu"
        ></v-select>
        <v-checkbox
          color="#0F998E"
          v-model="sortOrderCheckbox"
          label="Samodejno nastavi vrstni red"
          @change="toggleAutoSortOrder"
        ></v-checkbox>
        <v-text-field
          v-if="!sortOrderCheckbox"
          v-model="form.sort_order"
          type="number"
          label="Željena pozicija tipa plačila"
        ></v-text-field>
        <v-checkbox
          color="#0F998E"
          v-model="form.is_visible"
          label="Je viden"
        ></v-checkbox>
        <v-btn type="submit" class="float-right">Shrani</v-btn>
        <v-btn text type="button" class="float-right mr-4" @click="$router.go(-1)">Prekliči</v-btn>
      </form>
    </v-col>
  </v-row>
</template>

<script>
import { required, requiredIf } from 'vuelidate/lib/validators'
import FormErrors from '@/components/FormErrors'
import FormErrorsLine from '@/components/FormErrorsLine'
import { parsePrice } from '@/utils/price'
import moment from 'moment'
import DateSelector from './DateSelector.vue'

export default {
  components: {
    FormErrors,
    FormErrorsLine,
    DateSelector
  },
  props: {
    paymentType: {
      default: () => {},
      type: Object
    }
  },
  data () {
    return {
      sortOrderCheckbox: true,
      printPaymentTypes: [
        {
          id: 1,
          name: 'Gotovinsko'
        },
        {
          id: 2,
          name: 'Negotovinsko'
        }
      ],
      form: {
        name: null,
        value: null,
        discount: null,
        new_value: null,
        start_date: null,
        sort_order: null,
        is_visible: true,
        print_payment_type: 1
      }
    }
  },
  validations: {
    form: {
      name: {
        required
      },
      start_date: {
        required: requiredIf(function (form) {
          return form.new_value > 0
        })
      }
    }
  },
  methods: {
    save () {
      this.$v.$touch()
      if (!this.$v.form.$error) {
        if (parseFloat(this.form.new_value) <= 0) {
          this.form = {
            name: this.form.name,
            value: this.form.value,
            discount: this.form.discount,
            sort_order: this.form.sort_order,
            is_visible: this.form.is_visible,
            print_payment_type: 1
          }
        }
        this.$emit('save', { data: this.form })
      }
    },
    cancel () {
      this.$emit('cancel')
    },
    updateDate ({ date }) {
      this.form.start_date = date
    },
    toggleAutoSortOrder () {
      if (this.sortOrderCheckbox) {
        this.form.sort_order = null
      }
    },
    parseFormPrice () {
      if (this.form.value) {
        this.form.value = parsePrice(this.form.value)
      }
    },
    parseDiscountPrice () {
      if (this.form.discount) {
        if (this.form.discount > 99.99) {
          this.form.discount = 99.99
        }
        if (this.form.discount < 1) {
          this.form.discount = 1
        }
        this.form.discount = this.form.discount
      }
    },
    parseFutureFormPrice () {
      if (this.form.new_value) {
        this.form.new_value = parsePrice(this.form.new_value)
      }
    }
  },
  created () {
    if (this.paymentType) {
      this.form = { ...this.form, ...this.paymentType, value: parsePrice(this.paymentType.value), discount: this.paymentType.discount, new_value: parsePrice(this.paymentType.new_value), start_date: this.paymentType.start_date ? moment(this.paymentType.start_date).format('YYYY-MM-DD') : null }
    }
  }
}
</script>
